module.exports = __webpack_public_path__ + "static/Quebec-e71c0c261b5066552e9519f078a59c80.png";